import React from "react";
import { RadioGroup, Text } from "@merge-api/merge-javascript-shared";
import type { ProductKey } from "@merge-api/merge-javascript-shared";
import ProductOption from "./ProductOption";
import { EXPLORE_MERGE_DESCRIPTION } from "../constants";
import { ExploreMergeOption } from "../types";

interface Props {
  options: ExploreMergeOption[];
  selectedProduct: ProductKey | null;
  onSelectProduct: (product: ProductKey) => void;
}

const ProductChoice = ({ options, selectedProduct, onSelectProduct }: Props) => {
  // render
  return (
    <div className="flex flex-col gap-4">
      <Text>{EXPLORE_MERGE_DESCRIPTION}</Text>
      <RadioGroup
        value={selectedProduct ?? ""}
        onValueChange={(value) => onSelectProduct(value as ProductKey)}
        className="flex flex-col gap-3"
      >
        {options.map((option) => (
          <ProductOption key={option.product} option={option} onSelect={onSelectProduct} />
        ))}
      </RadioGroup>
    </div>
  );
};

export default ProductChoice;
